/**
 * SmileFresh thank-you page helper.
 * Timely custom confirmation redirects here with transactionId/value/description
 * OR (Shopify/theme path) bookingId + serviceName + email/phone (seen 10 Sep 2026).
 * Pair stored Ads click ids (from gclid-passthrough-snippet.js) with this booking
 * so offline Timely-paid uploads can use a real gclid later.
 */
(function () {
  var STORE = 'sf_gads_click_ids';
  var JOIN = 'sf_gads_booking_joins';
  var SHEET =
    window.SF_GCLID_JOIN_WEBHOOK ||
    'https://script.google.com/macros/s/AKfycbz0801VUdTEebiNC0YhmmJwAJ3GWUAWeGmqC0wzGtviD_lc3wOobbd3gSdN-BIoEkdg/exec';

  var q = new URLSearchParams(location.search);
  var transactionId =
    q.get('transactionId') ||
    q.get('transaction_id') ||
    q.get('bookingId') ||
    q.get('booking_id') ||
    '';
  var value = q.get('value') || '';
  var description = q.get('description') || q.get('serviceName') || '';
  if (!transactionId) return;

  var ids = {};
  try { ids = JSON.parse(localStorage.getItem(STORE) || '{}') || {}; } catch (e) {}
  var gclid = ids.gclid || q.get('gclid') || '';
  var gbraid = ids.gbraid || q.get('gbraid') || '';
  var wbraid = ids.wbraid || q.get('wbraid') || '';

  var row = {
    saved_at: Date.now(),
    transactionId: transactionId,
    value: value,
    description: description,
    gclid: gclid || null,
    gbraid: gbraid || null,
    wbraid: wbraid || null,
    path: location.pathname,
    email: q.get('email') || null,
    phone: q.get('phone') || q.get('phone_number') || null
  };

  try {
    var joins = JSON.parse(localStorage.getItem(JOIN) || '[]');
    if (!Array.isArray(joins)) joins = [];
    joins.push(row);
    localStorage.setItem(JOIN, JSON.stringify(joins.slice(-50)));
  } catch (e) {}

  window.sfGadsBookingJoin = row;

  try {
    var data = new FormData();
    data.append('event_type', 'gclid_join');
    data.append('transaction_id', transactionId);
    data.append('value', value || '0');
    data.append('description', description || '');
    data.append('page_url', location.href);
    if (gclid) data.append('gclid', gclid);
    if (gbraid) data.append('gbraid', gbraid);
    if (wbraid) data.append('wbraid', wbraid);
    if (row.email) data.append('email', row.email);
    if (row.phone) data.append('phone', row.phone);
    fetch(SHEET, { method: 'POST', mode: 'no-cors', body: data }).catch(function () {});
  } catch (e) {}
})();
